"use client";
import { useEffect, useState } from "react";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import AddJob from "../../../components/admin/jobs/AddJobs";
import EditJobs from "../../../components/admin/jobs/EditJobs";
import { useLocation } from "react-router";
import { getJob } from "../../../services/jobsServices";

const EditJob = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const jobId = searchParams.get("jobId");
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!jobId) return;

    const fetchJob = async () => {
      try {
        setLoading(true);
        const data = await getJob(jobId);
        setJob(data.data);
      } catch (err) {
        setError(err.message || "Failed to load job");
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
  }, [jobId]);

  const handleGoBack = () => {
    window.location.href = "/admin/jobs/list";
  };
  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar */}
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <div className="flex items-start w-full gap-2">
                <button
                  onClick={handleGoBack}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm hover:shadow-md transition-shadow"
                  title="Go back"
                >
                  <span className="text-gray-600 text-lg">←</span>
                </button>{" "}
                <Header title="Edit Jobs" desc="Edit an title descrition" />
              </div>
              {loading && <p>Loading...</p>}
              {error && <p className="text-red">{error}</p>}

              {job && <EditJobs job={job} jobId={jobId} />}
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EditJob;
